import { observer } from 'mobx-react-lite'
import { type JobListViewModel } from '@/features/jobs/details/components/JobList/JobListViewModel'
import { JobSidebarHeader } from '@/features/jobs/details/components/JobSidebarHeader'

export interface JobSidebarHeaderContainerProps {
  vm: JobListViewModel
}

export const JobSidebarHeaderContainer = observer(
  function JobSidebarHeaderContainer({ vm }: JobSidebarHeaderContainerProps) {
    return (
      <JobSidebarHeader
        searchText={vm.searcher.searchText.value}
        onSearch={vm.search}
        savedFilters={vm.searcher.savedFilters}
        selectedSavedFilterId={vm.searcher.savedFilter?.id ?? null}
        onSelectSavedFilter={vm.selectSavedFilter}
      />
    )
  },
)
